(() => {
  if (customElements.get('vertaro-unified-localization')) return;

  customElements.define('vertaro-unified-localization', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.menu = this.querySelector('details');
      this.select = this.querySelector('[data-region-currency-select]');
      if (!this.menu || !this.select) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.select.addEventListener('change', () => this.changeCurrency(), options);
      this.querySelector('form')?.addEventListener('change', (event) => {
        if (event.target instanceof HTMLSelectElement) event.currentTarget.requestSubmit();
      }, options);
      const refresh = () => {
        this.retryUntil = Date.now() + 60000;
        this.schedule();
      };
      window.addEventListener('BUCKS_SELECTED_CURRENCY', refresh, options);
      document.addEventListener('BUCKS_SELECTED_CURRENCY', refresh, options);
      window.addEventListener('BUCKSCC-LOADED', refresh, options);
      this.menu.addEventListener('toggle', () => {
        if (this.menu.open) refresh();
      }, options);
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.menu.open = false;
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.menu.open) {
          this.menu.open = false;
          this.querySelector('summary').focus();
          event.stopPropagation();
        }
      }, options);
      this.observer = new MutationObserver(() => this.schedule());
      this.retryUntil = Date.now() + 60000;
      this.sync();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      this.wrapper = null;
      cancelAnimationFrame(this.frame);
      clearTimeout(this.retryTimer);
      this.frame = 0;
      document.documentElement.classList.remove('vertaro-region-ready');
    }

    schedule() {
      if (this.frame || !this.isConnected) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        if (this.isConnected) this.sync();
      });
    }

    sync() {
      clearTimeout(this.retryTimer);
      const wrapper = this.wrapper?.isConnected ? this.wrapper : document.querySelector('.buckscc-currency-wrapper');
      // Header hydration replaces the drawer markup on first interaction.
      // Keep the app's live controls outside that subtree so its listeners survive.
      const appBox = wrapper?.closest('.buckscc-currency-box');
      if (appBox?.closest('header-component')) document.body.appendChild(appBox);
      if (wrapper !== this.wrapper) {
        this.observer.disconnect();
        this.wrapper = wrapper;
        if (wrapper) this.observer.observe(wrapper, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class', 'id']
        });
      }
      const selected = wrapper?.querySelector('.bucks-selected')?.textContent.trim();
      const triggers = Array.from(wrapper?.querySelectorAll('.buckscc-select-options .converterTriggers') || []);
      const currencies = new Map();
      for (const trigger of triggers) {
        if (/^[A-Z]{3}$/.test(trigger.id)) currencies.set(trigger.id, trigger.querySelector('.bucksItem')?.textContent.trim() || trigger.id);
      }
      const ready = !!window.bucksCC?.rendered && /^[A-Z]{3}$/.test(selected || '') && currencies.size > 0;
      this.hidden = !ready;
      document.documentElement.classList.toggle('vertaro-region-ready', ready);
      if (!ready) {
        if (Date.now() < this.retryUntil) this.retryTimer = setTimeout(() => this.schedule(), 1000);
        return;
      }
      if (!currencies.has(selected)) currencies.set(selected, selected);
      const signature = JSON.stringify(Array.from(currencies));
      if (this.signature !== signature) {
        this.select.replaceChildren(...Array.from(currencies, ([code, label]) => new Option(label, code)));
        this.signature = signature;
      }
      this.select.value = selected;
      const label = this.querySelector('[data-region-currency]');
      if (label.textContent !== selected) label.textContent = selected;
      const sourceFlag = wrapper.querySelector('.buckscc-select-styled .hxoFlag');
      const flag = this.querySelector('[data-region-flag]');
      if (this.flagClass !== sourceFlag?.className) {
        flag.replaceChildren(...(sourceFlag ? [sourceFlag.cloneNode(true)] : []));
        this.flagClass = sourceFlag?.className;
      }
      this.querySelector('[data-region-checkout]').hidden = !!window.bucksCC?.metaConfig?.multiCurrencyEnabled;
    }

    changeCurrency() {
      const target = Array.from(this.wrapper?.querySelectorAll('.buckscc-select-options .converterTriggers') || []).find((item) => item.id === this.select.value);
      if (!target) { this.sync(); return; }
      target.click();
      this.schedule();
    }
  });
})();

